import { FieldMetaProps } from 'formik';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hasSuccess = (meta: FieldMetaProps<any>) => meta.touched && !meta.error;
